export const loadIcons = () => {
  const requireAll = (requireContext) =>
    requireContext.keys().map(requireContext);
  const req = require.context('../src/assets/icons', false, /\.svg$/);
  requireAll(req);
};
